import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import img1 from "../../assets/images/corporate-page/air-india-2.png";
import img2 from "../../assets/images/corporate-page/Tresemme.png";
import img3 from "../../assets/images/corporate-page/airtel-2.png";
import img4 from "../../assets/images/corporate-page/cii.png";
import img5 from "../../assets/images/corporate-page/croplife-india.png";
import img6 from "../../assets/images/corporate-page/discovery-plus.jpg";
import img7 from "../../assets/images/corporate-page/docubay.png";
import img9 from "../../assets/images/corporate-page/gmc.png";
import img10 from "../../assets/images/corporate-page/iqoo.png";
import img11 from "../../assets/images/corporate-page/jk-tyre.png";
import img12 from "../../assets/images/corporate-page/jojo.png";
import img13 from "../../assets/images/corporate-page/juggernaut.png";
import img14 from "../../assets/images/corporate-page/mamaearth-2.png";
import img15 from "../../assets/images/corporate-page/renew.png";
import img16 from "../../assets/images/corporate-page/samsung.png";
import img17 from "../../assets/images/corporate-page/shark-tank.png";
import img18 from "../../assets/images/corporate-page/toothsi.png";
import img19 from "../../assets/images/corporate-page/warner-bros-2.png";

const PARTNERS = [
  {
    alt: "Air India",
    src: img1,
  },
  {
    alt: "Tresemme",
    src: img2,
  },
  {
    alt: "JK Tyre",
    src: img11,
  },
  {
    alt: "Airtel",
    src: img3,
  },
  {
    alt: "CII",
    src: img4,
  },
  {
    alt: "Croplife",
    src: img5,
  },
  {
    alt: "Discovery",
    src: img6,
  },
  {
    alt: "Docubay",
    src: img7,
  },
  {
    alt: "GMC",
    src: img9,
  },
  {
    alt: "IQOO",
    src: img10,
  },
  {
    alt: "Jojo",
    src: img12,
  },
  {
    alt: "Juggernaut",
    src: img13,
  },
  {
    alt: "Mamaearth",
    src: img14,
  },
  {
    alt: "Renew",
    src: img15,
  },
  {
    alt: "Samsung",
    src: img16,
  },
  {
    alt: "Shark Tank",
    src: img17,
  },
  {
    alt: "Toothsi",
    src: img18,
  },
  {
    alt: "Warner Bros",
    src: img19,
  },
];

const CorporatePartners = () => {
  return (
    <div className="logo-slider-container">
      <Swiper
        modules={[Autoplay]}
        loop={true}
        speed={3000}
        autoplay={{
          delay: 0, // 0 delay makes it a continuous motion
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        }}
        // Mobile-first responsive breakpoints
        breakpoints={{
          320: { slidesPerView: 2, spaceBetween: 20 },
          480: { slidesPerView: 3, spaceBetween: 30 },
          768: { slidesPerView: 4, spaceBetween: 40 },
          1024: { slidesPerView: 5, spaceBetween: 40 },
          1280: { slidesPerView: 6, spaceBetween: 50 },
        }}
        className="endless-logo-swiper"
      >
        {PARTNERS.map((partner) => (
          <SwiperSlide key={partner.alt}>
            <div className="logo-box">
              <img
                loading="lazy"
                decoding="async"
                src={partner.src}
                alt={`${partner.alt} logo`}
                className="logo-img"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default CorporatePartners;
